import { Box, Button, Typography } from "@mui/material";
import styles from "../../pages/academy/academy.module.css";
import Her from "../../assets/her.png";
import herSmall from "../../assets/she.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import React, { useState, useEffect } from "react";
import {fontType} from "../../constants/font";
import InfoBanner from "./InfoBanner";

const Intro = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });
  // width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Update the window width when the component mounts
    setWindowWidth(window.innerWidth);

    // Add event listener to update the window width on resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#7b7cd5",
        display: "flex",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
          maxWidth: "1800px",
          width: "100%",
        }}
      >
        <img
          className={styles.element}
          style={{
            marginLeft: "650px",
            position: "absolute",
            top: 70,
            zIndex: 2,
            display: windowWidth > 700 ? "unset" : "none",
          }}
          src={require("../../assets/elements.png")}
          alt="intro_floating_icons"
        />
          {windowWidth >= 600 && <InfoBanner isMainPage={true} windowWidth={windowWidth} />}
        {windowWidth > 550 ? (
          <Box
            sx={{
              backgroundImage: `url(${Her})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              height: "630px",
              maxWidth: "1440px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              paddingTop: "10px",
              position: "relative",
            }}
          >
            <motion.div
              ref={ref}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.7 }}
            >
              <Box
                sx={{
                  maxWidth: { md: "580px", xs: "355px" },
                  marginLeft: "6.6vw",
                  marginRight: "6.6vw",
                  position: "relative",
                  zIndex: 3,
                }}
              >
                <Box sx={{ marginLeft: "12px", marginBottom: "27px" }}>
                  <Typography
                    sx={{
                      fontSize: { md: 55, xs: 35 },
                      fontFamily: fontType.regular,
                      color: "#1b144a",
                      lineHeight: { md: "65px", xs: 1.2 },
                      marginBottom: "21px",
                    }}
                  >
                    <span style={{ color: "white" }}>AA</span>B<span style={{ color: "white" }}>S</span>OLVUJ školenie, <br />s ktorým budeš <br />
                    napredovať
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { md: 28, xs: 22 },
                      fontFamily: fontType.medium,
                      color: "#1b144a",
                      lineHeight: { md: "38px", sx: 1.2 },
                    }}
                  >
                    Poskytujeme akreditované ISTQB školenia a odborné špecializované školenia rôznych oblastí testovania.
                  </Typography>
                </Box>
                <Box>
                  <Link to="/skolenia" style={{ textDecoration: "none" }}>
                    <Button
                      sx={{
                        borderRadius: "28px",
                        backgroundColor: "#f6961d",
                        fontFamily: fontType.semiBold,
                        fontSize: 16,
                        cursor: "pointer",
                        color: "white",
                        height: "55px",
                        width: "186px",
                        marginRight: "14px",
                        marginTop: { xs: "10px", md: "0px" },
                        textTransform: "initial",
                        "&:hover": {
                          backgroundColor: "#3fcaea",
                        },
                      }}
                    >
                        Vybrať školenie
                    </Button>
                  </Link>
                </Box>
              </Box>
            </motion.div>
          </Box>
        ) : (
          <Box
            sx={{
              maxWidth: "1440px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              paddingTop: "10px",
              position: "relative",
            }}
          >
            <motion.div
              ref={ref}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.7 }}
              style={{ width: "100%", marginTop: "50px" }}
            >
              <Box
                sx={{
                  maxWidth: { md: "580px", xs: "355px" },
                  marginLeft: "6.6vw",
                  marginRight: "6.6vw",
                  position: "relative",
                  zIndex: 3,
                }}
              >
                <Box sx={{ marginLeft: "12px", marginBottom: "27px" }}>
                  <Typography
                    sx={{
                      fontSize: { md: 55, xs: 35 },
                      fontFamily: fontType.regular,
                      color: "#1b144a",
                      lineHeight: { md: "65px", xs: 1.2 },
                      marginBottom: "21px",
                    }}
                  >
                    <span style={{ color: "white" }}>AA</span>B<span style={{ color: "white" }}>S</span>OLVUJ školenie, <br />s ktorým budeš <br />
                    napredovať
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { md: 28, xs: 22 },
                      fontFamily: fontType.medium,
                      color: "#1b144a",
                      lineHeight: { md: "38px", sx: 1.2 },
                    }}
                  >
                    Poskytujeme akreditované ISTQB školenia a odborné špecializované školenia rôznych oblastí testovania.
                  </Typography>
                </Box>
                <Box>
                  <Link to="/skolenia" style={{ textDecoration: "none" }}>
                    <Button
                      sx={{
                        borderRadius: "28px",
                        backgroundColor: "#f6961d",
                        fontFamily: fontType.semiBold,
                        fontSize: 16,
                        cursor: "pointer",
                        color: "white",
                        height: "55px",
                        width: "186px",
                        marginRight: "14px",
                        marginTop: { xs: "10px", md: "0px" },
                        textTransform: "initial",
                        "&:hover": {
                          backgroundColor: "#3fcaea",
                        },
                      }}
                    >
                        Vybrať školenie
                    </Button>
                  </Link>
                </Box>
              </Box>
              <Box
                sx={{
                  position: "relative",
                  height: "470px",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    width: "550px",
                    bottom: 20,
                  }}
                  src={herSmall}
                  alt="her_small"
                />
                <img
                  className={styles.element}
                  style={{
                    marginRight: "-350px",
                    position: "absolute",
                    top: -45,
                    zIndex: 2,
                  }}
                  src={require("../../assets/elements.png")}
                  alt="intro_floating_icons"
                />
              </Box>
            </motion.div>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Intro;
